<script>
/**
 * 全站页脚（自 vancheen-b2b 的 AppFooter.vue 移植为 Vue 2 版本）
 */
import NhSvgIcon from './NhSvgIcon.vue'
import NhLink from './NhLink.vue'
import asset from '../nh-asset'
import { t } from '../nh-i18n'
import { getSite } from '../nh-site-data'

export default {
  name: 'NhFooter',
  components: { NhSvgIcon, NhLink },
  computed: {
    logoUrl() {
      return asset('logo.png')
    },
    COMPANY() {
      return getSite('COMPANY')
    },
    CONTACT() {
      return getSite('CONTACT')
    },
    FOOTER() {
      return getSite('FOOTER')
    }
  },
  methods: {
    asset,
    t
  }
}
</script>

<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-main">
        <div class="footer-brand">
          <NhLink to="/" class="logo">
            <span class="logo-mark"><img :src="logoUrl" alt="T&amp;W logo"></span>
            <span class="logo-text">
              <strong style="color:#fff">{{ COMPANY.name }}</strong>
              <span>{{ COMPANY.subtitle }}</span>
            </span>
          </NhLink>
          <p>{{ FOOTER.intro }}</p>
          <div class="footer-social">
            <a v-for="s in FOOTER.social" :key="s.label" :aria-label="s.label">
              <img :src="asset(s.img)" :alt="s.label">
            </a>
          </div>
        </div>

        <div class="footer-col">
          <h4>{{ t('footer.quickLinks') }}</h4>
          <ul class="footer-links">
            <li v-for="l in FOOTER.quickLinks" :key="l.label">
              <NhLink :to="l.to">{{ l.label }}</NhLink>
            </li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>{{ t('footer.productLines') }}</h4>
          <ul class="footer-links">
            <li v-for="l in FOOTER.productLines" :key="l.label">
              <NhLink>{{ l.label }}</NhLink>
            </li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>{{ t('footer.contact') }}</h4>
          <ul class="footer-contact">
            <li><NhSvgIcon name="pin" /><span>{{ CONTACT.addr }}</span></li>
            <li><NhSvgIcon name="phone" /><a :href="CONTACT.phoneHref">{{ CONTACT.phone }}</a></li>
            <li><NhSvgIcon name="mail" /><a :href="'mailto:' + CONTACT.email">{{ CONTACT.email }}</a></li>
            <li>
              <img :src="asset('facebook.png')" style="width:17px;height:17px;margin-top:3px;" alt="Facebook">
              <span>{{ CONTACT.faceBook }}</span>
            </li>
          </ul>
          <div class="footer-newsletter"></div>
        </div>
      </div>

      <div class="footer-bottom">
        <span>{{ FOOTER.copyright }}</span>
        <span>
          <!-- legal 链接：单层 v-for，key 挂在实际元素上，分隔符「·」用 v-if 控制 -->
          <span
            v-for="(l, i) in FOOTER.legal"
            :key="l.label"
          ><a :href="l.href">{{ l.label }}</a><span v-if="i < FOOTER.legal.length - 1"> · </span></span>
        </span>
      </div>
    </div>
  </footer>
</template>
